import { definitions } from "@/services/metruyenvl"

export const createReducerPagingKey = (paging: definitions["v_api.Paging"]): string => {
    return paging.page_size + "-" + paging.current_page
}
